
import * as React from 'react';
import { Action } from 'redux';
import { connect } from 'react-redux';
import * as Creators from '../../actions/creators';
import { get } from 'lodash';
import {ICanaryMetricConfig, ICanaryState, DisableableInput, DISABLE_EDIT_CONFIG, FormRow} from '@spinnaker/kayenta';

interface IDynatraceMetricConfigurerStateProps {
    editingMetric: ICanaryMetricConfig;
}

interface IDynatraceMetricConfigurerDispatchProps {
  changeInlineTemplate: (event: any) => void;
}

type IDynatraceMetricConfigurerProps = IDynatraceMetricConfigurerStateProps & IDynatraceMetricConfigurerDispatchProps;

export const queryFinder = (metric: ICanaryMetricConfig) => get(metric, 'query.customInlineTemplate', '');

/*
 * Component for configuring a Dynatrace metric
 */
function DynatraceMetricConfigurer({ changeInlineTemplate, editingMetric }: IDynatraceMetricConfigurerProps) {
    return (
      <>
          <FormRow label="Dynatrace USQL" inputOnly={true}>
              <DisableableInput
                type="text"
                value={queryFinder(editingMetric)}
                onChange={changeInlineTemplate}
                disabledStateKeys={[DISABLE_EDIT_CONFIG]}
              />
          </FormRow>
      </>
    );
  }


function mapStateToProps(state: ICanaryState): IDynatraceMetricConfigurerStateProps {
  return {
    editingMetric: state.selectedConfig.editingMetric,
  };
}

function mapDispatchToProps(dispatch: (action: Action & any) => void): IDynatraceMetricConfigurerDispatchProps {
  return {
    changeInlineTemplate: (event: any) => {
      dispatch(Creators.updateDynatraceInlineTemplate({ value: event.target.value }));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DynatraceMetricConfigurer);
